<template>
  <div class="px-3">
    <material-card
      color="orange"
      title="Quarterly Attestation Report">
      <v-layout
        class="account-filters"
        justify-space-between
        wrap>
        <v-flex md4>
          <v-select
            :items="quarters"
            v-model="attestationReport.selectedQtr"
            attach
            label="Select Quarter"
          />
        </v-flex>
        <!-- <v-flex md2>
          <v-text-field
            v-model="search"
            label="Search"
            single-line
            hide-details
            append-icon="search"
          />
        </v-flex> -->
      </v-layout>
      <v-data-table
        ref="accountList"
        :headers="getAttestationHeaders"
        :items="filteredMasterpayers"
        :pagination.sync="pagination"
        class="accounts-table"
        loading
        loading-text="Loading... Please wait"
        item-key="master_payer"
      >
        <template
          slot="headerCell"
          slot-scope="{ header }">
          <span
            class="subheading font-weight-light text-success text-md-left text--darken-3"
            v-text="header.text"
          />
        </template>
        <template v-slot:items="props">
          <tr>
            <td>{{ props.item.master_payer }}</td>
            <td><a
              v-if="props.item.new_accounts > 0"
              href="javascript:void(0)"
              @click="onOpenAccounts('new_accounts', props.item.master_payer)">{{ props.item.new_accounts }}</a>
              <span v-else>{{ props.item.new_accounts }}</span>
            </td>
            <td><a
              v-if="props.item.current_active > 0"
              href="javascript:void(0)"
              @click="onOpenAccounts('current_active', props.item.master_payer)">{{ props.item.current_active }}</a>
              <span v-else>{{ props.item.current_active }}</span>
            </td>
            <td><a
              v-if="props.item.last_qtr_active > 0"
              href="javascript:void(0)"
              @click="onOpenAccounts('last_qtr_active', props.item.master_payer)">{{ props.item.last_qtr_active }}</a>
              <span v-else>{{ props.item.last_qtr_active }}</span>
            </td>
            <td><a
              v-if="props.item.suspended > 0"
              href="javascript:void(0)"
              @click="onOpenAccounts('suspended', props.item.master_payer)">{{ props.item.suspended }}</a>
              <span v-else>{{ props.item.suspended }}</span>
            </td>
            <!-- <td><a
              v-if="props.item.reported_count > 0"
              href="javascript:void(0)"
              @click="onOpenAccounts('reported_count', props.item.master_payer)">{{ props.item.reported_count }}</a>
              <span v-else>{{ props.item.reported_count }}</span>
            </td> -->
            <td><a
              v-if="props.item.active_accounts_left > 0"
              href="javascript:void(0)"
              @click="onOpenAccounts('active_accounts_left', props.item.master_payer)">{{ props.item.active_accounts_left }}</a>
              <span v-else>{{ props.item.active_accounts_left }}</span>
            </td>
            <td><a
              v-if="props.item.suspended_accounts_left > 0"
              href="javascript:void(0)"
              @click="onOpenAccounts('suspended_accounts_left', props.item.master_payer)">{{ props.item.suspended_accounts_left }}</a>
              <span v-else>{{ props.item.suspended_accounts_left }}</span>
            </td>
          </tr>
        </template>
      </v-data-table>

    </material-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
    quarters: [
      {
        text: `First Quarter (Dec 1 ${new Date().getFullYear() - 1}-Feb 28 ${new Date().getFullYear()})`,
        value: 0,
        columnLabel: '(Dec 1-Feb 28)',
        fromDate: `${new Date().getFullYear() - 1}-12-01`,
        toDate: `${new Date().getFullYear()}-02-28`
      },
      {
        text: `Second Quarter (Mar 1 ${new Date().getFullYear()}-May 31 ${new Date().getFullYear()})`,
        value: 1,
        columnLabel: '(Mar 1-May 31)',
        fromDate: `${new Date().getFullYear()}-03-01`,
        toDate: `${new Date().getFullYear()}-05-31`
      },
      {
        text: `Third Quarter (Jun 1 ${new Date().getFullYear()}-Aug 31 ${new Date().getFullYear()})`,
        value: 2,
        columnLabel: '(Jun 1-Aug 31)',
        fromDate: `${new Date().getFullYear()}-06-01`,
        toDate: `${new Date().getFullYear()}-08-31`
      },
      {
        text: `Fourth Quarter (Sep 1 ${new Date().getFullYear()}-Nov 30 ${new Date().getFullYear()})`,
        value: 3,
        columnLabel: '(Sep 1-Nov 30)',
        fromDate: `${new Date().getFullYear()}-09-01`,
        toDate: `${new Date().getFullYear()}-11-30`
      }
    ],
    // selectedQtr: 0,
    isQuarterSelected: false,
    currentYear: new Date().getFullYear(),
    previousYear: new Date().getFullYear() - 1,
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0
    }
  }),
  computed: {
    ...mapState('admin/accountInventory', ['attestationReportHeaders', 'attestationReport', 'masterAccounts']),
    getAttestationHeaders () {
      var self = this
      let filterMasterPayersHeaders = this.attestationReportHeaders.map(header => {
        switch (header.value) {
          case 'new_accounts':
          // case 'current_active':
          case 'suspended':
          case 'reported_count':
          case 'active_accounts_left':
            return { ...header, text: `${header.text} ${self.quarters[self.attestationReport.selectedQtr].columnLabel}` }
          default:
            return header
        }
      })

      return filterMasterPayersHeaders
    },
    filteredMasterpayers () {
      let dataColumns = {
        new_accounts: 0, // Account_Status is New
        current_active: 0, // Account_Status is ACTIVE
        suspended: 0, // Account_Status is SUSPENDED
        active_accounts_left: 0, // if the Acct_Status is Moved to Client or Moved to Masterpayer
        suspended_accounts_left: 0, // Date_onboarded for the last 90 days and Account_Status is ACTIVE
        last_qtr_active: 0, // Previous Quarter count the ACTIVE accounts
        reported_count: 0
      }

      let reportData = {
        ppa: { ...dataColumns },
        spp: { ...dataColumns },
        // sp: { ...dataColumns },
        legacy: { ...dataColumns },
        // others: { ...dataColumns }
      }

      let accounts = this.masterAccounts.filter(account => window.moment(account.Date_onboarded) > window.moment(this.quarters[this.attestationReport.selectedQtr].fromDate) && window.moment(account.Date_onboarded) < window.moment(this.quarters[this.attestationReport.selectedQtr].toDate))
      // loop through accounts
      accounts.forEach(account => {
        switch (account.agreement) {
          case 'ppa':
          case 'spp':
          case 'legacy':
            // if (account.Acct_Status === 'New') {
            //   reportData[account.agreement].new_accounts += 1
            // } else 
            if (account.Acct_Status === 'ACTIVE') {
              reportData[account.agreement].new_accounts += 1
              // reportData[account.agreement].current_active += 1
              reportData[account.agreement].reported_count += 1
            } else if (account.Acct_Status === 'SUSPENDED') {
              reportData[account.agreement].suspended += 1
              reportData[account.agreement].reported_count += 1
            } 
            // else if (account.Acct_Status === 'Moved to Client' || account.Acct_Status === 'Moved to Masterpayer') {
            //   reportData[account.agreement].active_accounts_left += 1
            // }
            break
          case 'edp - vale':
            if (account.Acct_Status === 'ACTIVE') {
              reportData['spp'].new_accounts += 1
              // reportData[account.agreement].current_active += 1
              reportData['spp'].reported_count += 1
            } else if (account.Acct_Status === 'SUSPENDED') {
              reportData['spp'].suspended += 1
              reportData['spp'].reported_count += 1
            }
            // else if (account.Acct_Status === 'Moved to Client' || account.Acct_Status === 'Moved to Masterpayer') {
            //   reportData['spp'].active_accounts_left += 1
            // }
            break
          default:
            // if (account.Acct_Status === 'New') {
            //   reportData['others'].new_accounts += 1
            // } else 
            // if (account.Acct_Status === 'ACTIVE') {
            //   reportData['others'].new_accounts += 1
            //   // reportData['others'].current_active += 1
            //   reportData['others'].reported_count += 1
            // } else if (account.Acct_Status === 'SUSPENDED') {
            //   reportData['others'].suspended += 1
            //   reportData['others'].reported_count += 1
            // } else if (account.Acct_Status === 'Moved to Client' || account.Acct_Status === 'Moved to Masterpayer') {
            //   reportData['others'].active_accounts_left += 1
            // }
            break
        }
      })

      let firstQuarter = null
      if (this.attestationReport.selectedQtr === 0) {
        let currentMonth = new Date().getMonth()
        // if current Month is December
        if (currentMonth === 11) {
          firstQuarter = {
            fromDate: `${new Date().getFullYear()}-09-01`,
            toDate: `${new Date().getFullYear()}-11-30`
          }
        } else {
          firstQuarter = {
            fromDate: `${new Date().getFullYear() - 1}-09-01`,
            toDate: `${new Date().getFullYear() - 1}-11-30`
          }
        }
      }
      // initialise
      let lastQuarterActiveAccounts = []
      // if select quarter is first
      if (firstQuarter) {
        lastQuarterActiveAccounts = this.masterAccounts.filter(account => window.moment(account.Date_onboarded) < window.moment(firstQuarter.toDate) && account.Acct_Status === 'ACTIVE')
      } else {
        lastQuarterActiveAccounts = this.masterAccounts.filter(account => window.moment(account.Date_onboarded) < window.moment(this.quarters[this.attestationReport.selectedQtr - 1].toDate) && account.Acct_Status === 'ACTIVE')
      }
      // loop through last quarer active accounts
      lastQuarterActiveAccounts.forEach(account => {
        switch (account.agreement) {
          case 'ppa':
          case 'spp':
          case 'legacy':
            reportData[account.agreement].last_qtr_active += 1
            break
          case 'edp - vale':
            reportData['spp'].last_qtr_active += 1
            break
          default:
            // reportData['others'].last_qtr_active += 1
            break
        }
      })

      // last quarter active + selected quarter active
      // let currentActiveAccounts
      // if (firstQuarter) {
      //   currentActiveAccounts = this.masterAccounts.filter(account => window.moment(account.Date_onboarded) < window.moment(firstQuarter.toDate) && account.Acct_Status === 'ACTIVE')
      // } else {
      //   currentActiveAccounts = this.masterAccounts.filter(account => window.moment(account.Date_onboarded) < window.moment(this.quarters[this.attestationReport.selectedQtr].toDate) && account.Acct_Status === 'ACTIVE')
      // }

      let currentActiveAccounts = this.masterAccounts.filter(account => window.moment(account.Date_onboarded) < window.moment(this.quarters[this.attestationReport.selectedQtr].toDate) && account.Acct_Status === 'ACTIVE')
      // get current active
      // let currentActiveAccounts = this.masterAccounts.filter(account => window.moment(account.Date_onboarded) < window.moment(this.quarters[this.attestationReport.selectedQtr].toDate) && account.Acct_Status === 'ACTIVE')
      // loop through current active accounts
      currentActiveAccounts.forEach(account => {
        switch (account.agreement) {
          case 'ppa':
          case 'spp':
          case 'legacy':
            reportData[account.agreement].current_active += 1
            break
          case 'edp - vale':
            reportData['spp'].current_active += 1
            break
          default:
            // reportData['others'].current_active += 1
            break
        }
      })
      
      // Date_Suspended value should be more than 90 days up to todays' date and Account_Status is SUSPENDED
      let suspendedAccounts = this.masterAccounts.filter(account => {
        let dateSuspended = window.moment(account.Date_Suspended, 'YYYY-MM-DD')
        let lastDateValidated = window.moment(account.Last_Date_Validated, 'YYYY-MM-DD')
        let todaysDate = window.moment()
        return (window.moment.duration(todaysDate.diff(dateSuspended)).asDays() > 90 && account.Acct_Status === 'SUSPENDED') || (window.moment.duration(todaysDate.diff(lastDateValidated)).asDays() > 90 && account.Acct_Status === 'SUSPENDED')
      })

      // loop through suspended accounts for more than 90 days validated
      suspendedAccounts.forEach(account => {
        switch (account.agreement) {
          case 'ppa':
          case 'spp':
          case 'legacy':
            reportData[account.agreement].suspended_accounts_left += 1
            break
          case 'edp - vale':
            reportData['spp'].suspended_accounts_left += 1
            break
          default:
            // reportData['others'].suspended_accounts_left += 1
            break
        }
      })

      // get acctive accounts left based on Last_Date_Validated
      let activeAccountsLeft = this.masterAccounts.filter(account => window.moment(account.Last_Date_Validated) > window.moment(this.quarters[this.attestationReport.selectedQtr].fromDate) && window.moment(account.Last_Date_Validated) < window.moment(this.quarters[this.attestationReport.selectedQtr].toDate) && (account.Acct_Status === 'Moved to Client' || account.Acct_Status === 'Moved to Masterpayer'))

      activeAccountsLeft.forEach(account => {
        switch (account.agreement) {
          case 'ppa':
          case 'spp':
          case 'legacy':
            reportData[account.agreement].active_accounts_left += 1
            break
          case 'edp - vale':
            reportData['spp'].active_accounts_left += 1
            break
          default:
            break
        }
      })

      // initialise
      let attestationReportData = []

      for (const mp in reportData) {
        if (reportData.hasOwnProperty(mp)) {
          const mpReportData = { ...reportData[mp], master_payer: mp.toUpperCase() }
          attestationReportData.push(mpReportData)
        }
      }

      return attestationReportData
    }
  },
  methods: {
    onOpenAccounts (status, mp) {
      console.log('opening accounts')
      this.$router.push({ path: `/admin/master-payer-report/list/${status}?mp=${mp.toLowerCase()}&quarter=${this.attestationReport.selectedQtr}` })
    }
  }
}
</script>
<style lang="scss" scoped>
table.v-table thead th:first-child {
  font-size: 10px;
}

.v-progress-linear {
      margin: 0;
      bottom: -15px;
  }

</style>
